export default __webpack_public_path__ + "static/green-dots-blob-206f5baae825d8ed4752e5c6200a13ad.svg";